import { useRef, useEffect, useState } from 'react';
import { BottomTooltip } from 'ui/tooltip';
import { Truncate } from 'ui/utility/truncate';

type CampaignTooltipProps = {
  id: string;
  text: string | number;
  maxWidth: number;
};

export const CampaignTooltip = ({ text, id, maxWidth }: CampaignTooltipProps) => {
  // truncated element references and state
  const textRef = useRef<HTMLButtonElement>(null);
  const textMaxWidth = maxWidth;
  const [isTextTruncated, setIsTextTruncated] = useState(false);

  useEffect(() => {
    if (
      textRef?.current?.offsetWidth &&
      textRef?.current?.offsetWidth < textRef?.current?.scrollWidth
    ) {
      setIsTextTruncated(true);
    } else if (
      textRef?.current?.offsetWidth &&
      textRef?.current?.offsetWidth > textRef?.current?.scrollWidth
    ) {
      setIsTextTruncated(false);
    }
  });

  return (
    <BottomTooltip isEnabled={isTextTruncated} tooltipContent={text}>
      <Truncate data-test={id} maxWidth={textMaxWidth} ref={textRef}>
        {text}
      </Truncate>
    </BottomTooltip>
  );
};
